import _regenerator from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.object.to-string.js";
export default {
  name: 'mapComponent',
  props: {
    beginAddress: {
      default: function _default() {
        return undefined;
      }
    },
    endAddress: {
      default: function _default() {
        return undefined;
      }
    },
    type: {
      default: function _default() {
        return 'view';
      }
    },
    warnMsg: {
      default: function _default() {
        return '';
      }
    },
    beginAddressTitle: {
      default: function _default() {
        return '';
      }
    },
    endAddressTitle: {
      default: function _default() {
        return '';
      }
    }
  },
  data: function data() {
    return {
      baiduMaoKey: '02f92f65958a9e6239ca601e321ba4d0',
      map: undefined,
      data: undefined,
      viewMap: undefined,
      mapId: "map-".concat(Date.now())
    };
  },
  methods: {
    cancel: function cancel() {
      this.$emit('cancel');
    },
    submit: function submit() {
      this.$emit('submit', this.data);
    },
    calculateDistance: function calculateDistance(lat1, lon1, lat2, lon2) {
      var earthRadius = 6371 * 1000; // 地球半径，单位为米

      // 将经纬度转换为弧度
      var radLat1 = Math.PI / 180 * lat1;
      var radLon1 = Math.PI / 180 * lon1;
      var radLat2 = Math.PI / 180 * lat2;
      var radLon2 = Math.PI / 180 * lon2;

      // 计算经纬度的差值
      var diffLat = radLat2 - radLat1;
      var diffLon = radLon2 - radLon1;

      // 应用Haversine公式计算距离
      var a = Math.pow(Math.sin(diffLat / 2), 2) + Math.cos(radLat1) * Math.cos(radLat2) * Math.pow(Math.sin(diffLon / 2), 2);
      var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
      var distance = earthRadius * c;
      return distance;
    },
    init: function init() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var self, lnglat, myGeo, begin, end, beginPoint, endPoint, points, beginLngLat, endLngLat, label;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _this.viewMap = new T.Map(_this.mapId);
              self = _this;
              lnglat = new T.LngLat(116.40969, 39.89945);
              _this.viewMap.centerAndZoom(lnglat, 15);
              _this.viewMap.clearOverLays();
              _this.viewMap.setMinZoom(5);
              _this.viewMap.setMaxZoom(18);
              // 添加缩放平移控件
              _this.viewMap.addControl(new T.Control.Zoom());
              _this.viewMap.addControl(new T.Control.Scale());
              myGeo = new T.Geocoder();
              _context.n = 1;
              return _this.getPoint(myGeo, _this.beginAddress);
            case 1:
              begin = _context.v;
              _context.n = 2;
              return _this.getPoint(myGeo, _this.endAddress);
            case 2:
              end = _context.v;
              _this.viewMap.panTo(begin.getLocationPoint(), 11);
              // 向地图上添加标注
              beginPoint = new T.Marker(begin.getLocationPoint());
              endPoint = new T.Marker(end.getLocationPoint());
              _this.viewMap.addOverLay(beginPoint);
              _this.viewMap.addOverLay(endPoint);
              beginPoint.addEventListener('click', function () {
                beginPoint.openInfoWindow(new T.InfoWindow("".concat(self.beginAddressTitle, ":").concat(self.beginAddress)));
              });
              endPoint.addEventListener('click', function () {
                endPoint.openInfoWindow(new T.InfoWindow("".concat(self.endAddressTitle, ":").concat(self.endAddress)));
              });
              points = [];
              beginLngLat = beginPoint.getLngLat();
              endLngLat = endPoint.getLngLat();
              points.push(new T.LngLat(beginLngLat.lng, beginLngLat.lat));
              points.push(new T.LngLat(endLngLat.lng, endLngLat.lat));
              // 向地图上添加线
              _this.viewMap.addOverLay(new T.Polyline(points));
              console.log(_this.viewMap);
              self.data = self.calculateDistance(beginLngLat.lat, beginLngLat.lng, endLngLat.lat, endLngLat.lng).toFixed(2);
              label = new T.Label({
                text: "\u4E24\u70B9\u4E4B\u95F4\u76F8\u8DDD ".concat(self.data > 1000 ? "".concat((self.data / 1000).toFixed(2), "(km)") : "".concat(self.data, "(m)")),
                position: {
                  lat: (beginLngLat.lat + endLngLat.lat) / 2,
                  lng: (beginLngLat.lng + endLngLat.lng) / 2
                }
              });
              _this.viewMap.addOverLay(label);
            case 3:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    getPoint: function getPoint(myGeo, address) {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var self;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              self = _this2;
              return _context2.a(2, new Promise(function (resolve, reject) {
                myGeo.getPoint(address, function (point) {
                  if (point && point.status === '0') {
                    resolve(point);
                  } else {
                    self.$message.warning('您选择的地址没有解析到结果！');
                    reject();
                  }
                });
              }));
          }
        }, _callee2);
      }))();
    },
    loadScript: function loadScript() {
      var self = this;
      return new Promise(function (resolve, reject) {
        window.baiduMap = function () {
          resolve();
        };
        var script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = "https://api.tianditu.gov.cn/api?v=4.0&tk=".concat(self.baiduMaoKey);
        script.onerror = reject;
        document.head.appendChild(script);
      });
    }
  },
  mounted: function mounted() {
    var _this3 = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.n) {
          case 0:
            if (!(!_this3.beginAddress || !_this3.endAddress)) {
              _context3.n = 1;
              break;
            }
            _this3.$message.warning(_this3.warnMsg);
            return _context3.a(2);
          case 1:
            _this3.data = undefined;
            _this3.viewMap = undefined;
            if (window.T) {
              _context3.n = 2;
              break;
            }
            _context3.n = 2;
            return _this3.loadScript();
          case 2:
            _this3.init();
          case 3:
            return _context3.a(2);
        }
      }, _callee3);
    }))();
  }
};